module.exports = __webpack_public_path__ + "img/xm.6ab5dc39.png";